import React from 'react';
import Button from './Button';

const BackButton = ({ children = '← Retour', className = '', ...props }) => (
  <Button
    variant="ghost"
    size="small"
    className={`back-button-common ${className}`.trim()}
    {...props}
  >
    {children}
  </Button>
);

export default BackButton;
